export const GET_CHAT_DATA_SUCCESS = 'GET_CHAT_DATA_SUCCESS';
export const GET_CHAT_DATA_REQUEST = 'GET_CHAT_DATA_REQUEST';
export const GET_CHAT_DATA_FAILED = 'GET_CHAT_DATA_FAILED';

export const ADD_CHAT_MESSAGE_REQUEST = 'ADD_CHAT_MESSAGE_REQUEST';
export const ADD_CHAT_MESSAGE_SUCCESS = 'ADD_CHAT_MESSAGE_SUCCESS';
export const ADD_CHAT_MESSAGE_FAILED = 'ADD_CHAT_MESSAGE_FAILED';

export const DISCARD_QC_REQUEST = 'DISCARD_QC_REQUEST';
export const DISCARD_QC_SUCCESS = 'DISCARD_QC_SUCCESS';
export const DISCARD_QC_FAILED = 'DISCARD_QC_FAILED';

export const DISCARD_FR_REQUEST = 'DISCARD_FR_REQUEST';
export const DISCARD_FR_SUCCESS = 'DISCARD_FR_SUCCESS';
export const DISCARD_FR_FAILED = 'DISCARD_FR_FAILED';
